module.exports = new __parcel__URL__("machines_shield_battery_level_3.86a01396.png").toString();